import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/wishcard/address.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-365fc323"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_2 = {
  class: "detail"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "richText"
};
var _hoisted_5 = {
  class: "location"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "left",
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_7 = {
  key: 0,
  class: "right"
};
var _hoisted_8 = {
  key: 1,
  class: "right"
};
var _hoisted_9 = {
  class: "time"
};
var _hoisted_10 = {
  key: 0,
  class: "detalImg"
};
var _hoisted_11 = {
  key: 1,
  class: "record"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_13 = {
  class: "block handle"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "red"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "redRight"
  }, " 跟进记录 ")], -1);
});

var _hoisted_15 = {
  class: "handle-content"
};
var _hoisted_16 = {
  class: "icon"
};
var _hoisted_17 = {
  key: 0,
  class: "line"
};
var _hoisted_18 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_19 = {
  class: "title"
};
var _hoisted_20 = {
  key: 0,
  class: "handle-imgbox"
};
var _hoisted_21 = {
  class: "footer"
};
var _hoisted_22 = {
  key: 0
};

var _hoisted_23 = /*#__PURE__*/_createTextVNode(" 认领 ");

var _hoisted_24 = {
  key: 1
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode(" 打卡 ");

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" 完成 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_previewImg = _resolveComponent("previewImg");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "心愿详情",
    back: true
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Data.detail.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Data.detail.richText), 1), _createElementVNode("div", _hoisted_5, [_hoisted_6, _ctx.Data.detail.location ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.Data.detail.location), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无地址 "))]), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.Data.detail.wishEndTime), 1), _ctx.Data.detail.imgUrls ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_previewImg, {
    width: "180rpx",
    height: "180rpx",
    list: _ctx.Data.detail.imgUrls
  }, null, 8, ["list"])])) : _createCommentVNode("", true), _ctx.Data.cardList.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.cardList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "handle-process"
    }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
      class: "spot",
      else: "",
      style: _normalizeStyle({
        background: index == 0 && _ctx.Data.detail.solverExist == 1 ? '#f5a426' : '#afb1bb'
      })
    }, null, 4), index != _ctx.Data.cardList.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
      class: "username",
      style: _normalizeStyle({
        color: index == 0 && _ctx.Data.detail.solverExist == 1 ? '#f5a426' : '#2d2f3b'
      })
    }, _toDisplayString(item.username), 5), _createElementVNode("div", {
      class: "publishDate",
      style: _normalizeStyle({
        color: index == 0 && _ctx.Data.detail.solverExist == 1 ? '#f5a426' : '#afb1bb'
      })
    }, _toDisplayString(item.publishDate), 5)]), _createElementVNode("div", {
      class: "details",
      style: _normalizeStyle({
        paddingBottom: index != _ctx.Data.cardList.length - 1 ? '20px' : 0
      })
    }, [_createElementVNode("div", {
      style: _normalizeStyle({
        color: index == 0 ? '#000' : '#2d2f3b'
      })
    }, _toDisplayString(item.comment), 5), item.cardUrls ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_previewImg, {
      width: "180rpx",
      height: "180rpx",
      list: item.cardUrls
    }, null, 8, ["list"])])) : _createCommentVNode("", true)], 4)])]);
  }), 128))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_ctx.Data.detail.solverExist == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_button, {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.operation(_ctx.Data.detail.id);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_23];
    }),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.Data.detail.solverExist == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_el_button, {
    class: "btn",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.toCard(_ctx.Data.detail.id);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_25];
    }),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "btn",
    style: {
      "background-color": "#ffffff",
      "color": "#c62423",
      "border": "solid 1px #c62423",
      "margin-left": "30px"
    },
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.finish(_ctx.Data.detail.id);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_26];
    }),
    _: 1
  })])) : _createCommentVNode("", true)])])], 64);
}